module.exports = __webpack_public_path__ + "static/img/UTSG老师_Mark.204478d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UTSG/UTSG老师_Mark.png
// module id = nXUF
// module chunks = 0